import LazyLoad from "react-lazyload";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";

const About = () => {
  const homeMenu = [
    { label: "Vision", link: "/about" },
    {
      label: "Management",
      link: "",
      subMenu: [
        { label: "Director's Message", link: "/DirectorMessage" },
        { label: "Principal's Message", link: "/PrincipalMessage" },
        { label: "Leadership Team", link: "/leadershipTeam" },
        { label: "Patron’s Message", link: "/patrons" },
        { label: "Advisory Board", link: "/advisoryBoard" },
      ],
    },

    { label: "International Collaborations", link: "/partnership" },
    // { label: "Awards & Achievements", link: "/awardsAcheivements" },

{
      label: "Awards & Achievements",
      link: "/awardsAcheivements",
      subMenu: [
        { label: "Accolades & Achievements", link: "/awardsAcheivements" },
        { label: "Students Achievements", link: "/studentsAcheivements" },
      ],
    },

    { label: "Faculty", link: "/faculty" },
    { label: "Staff Details", link: "/staffDetails" },
    { label: "School Strength ", link: "/schoolStrength" },
    {
      label: "Gallery",
      link: "/Gallery",
      subMenu: [
        { label: "Photo Gallery", link: "/Gallery" },
        { label: "Video Gallery", link: "/VideoGallery" },
      ],
    },
  ];
  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/banner-vision.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="Vision"
                breadEnd="Vision"
                breadMid="About Us"
              />
            </div>
          </div>
          <div className="row border-1">
            <div className="col-md-6 p-4">
              <div className="scroll-box">
                <h2 className="color-red text-center">Vision</h2>
                <p></p>
                <p>
                  At{" "}
                  <strong className="partnershipitalic">
                    Lotus Valley International School, Gurugram
                  </strong>
                  , we aspire to craft socially conscious, self-aware and
                  responsible global citizens who will construct, shape, and
                  serve society. The school proposes to create a system that is
                  aligned with the{" "}
                  <strong>
                    <em className="partnershipitalic">
                      aspirational goals of state-of-the-art education,
                      including SDG4
                    </em>
                  </strong>{" "}
                  while building upon India’s traditions and value systems. The
                  school lays particular emphasis on the development of the
                  creative potential of each individual based on the principle
                  that education must develop not only cognitive capacities but
                  also social, ethical, and emotional dimensions and
                  dispositions.
                </p>
                <p>
                  <strong>T</strong>he school aims at empowering each child with
                  a deep, broad, and strong fundament of knowledge and life
                  skills. We firmly believe in equipping our learners with 21
                  <sup>st</sup> Century Skills such as{" "}
                  <strong>
                    <em className="partnershipitalic">
                      Critical and Creative Thinking, Character Building,
                      Comprehension, Communication, Collaboration, Commitment,
                      Confidence, Digital Literacy, Leadership, Social Skills,
                      Initiative &amp; Innovation
                    </em>
                  </strong>{" "}
                  to facilitate holistic development and character building. We
                  strive to create a stimulating and inclusive environment where
                  children learn effortlessly and are supported by our
                  pioneering pedagogies in recognizing, achieving, and whetting
                  their innate potential.
                </p>
                <p>
                  <strong>T</strong>he goal is to create accomplished,
                  intrinsically motivated learners, capable of shaping the
                  Nation’s future. It is our consistent endeavour to enable
                  learners to flourish on an insightfully designed curriculum
                  that cradles Indian Ethos and Culture, thus facilitating their
                  moral and spiritual development. We are dedicated to edifying
                  them with the virtues of honesty, dignity, and justice, which
                  sets them on the decorous path from the very beginning.
                </p>
              </div>
            </div>
            <div className="col-md-6 p-0">
              <LazyLoad>
                {" "}
                <img
                  alt="lotus valley school, gurgaon"
                  className="img-fluid wid-100"
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vision.jpg"
                ></img>
              </LazyLoad>
            </div>
          </div>
          <div className="row border-1">
            <div className="col-md-6 p-0">
              <LazyLoad>
                {" "}
                <img
                  alt="lotus valley school, gurgaon"
                  className="img-fluid wid-100"
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/mission.jpg"
                ></img>
              </LazyLoad>
            </div>
            <div className="col-md-6 p-4">
              <div className="scroll-box">
                <h2 className="color-red text-center">Mission</h2>
                <p></p>
                <p>
                  <strong>O</strong>ur mission is to develop good human beings,
                  capable of{" "}
                  <strong className="partnershipitalic">
                    <em>independent rational thought and action,</em>
                  </strong>{" "}
                  with{" "}
                  <strong className="partnershipitalic">
                    <em>compassion and humaneness</em>
                  </strong>
                  , with{" "}
                  <strong className="partnershipitalic">
                    <em>
                      courage and resilience, with scientific temper and
                      creative groundbreaking imagination,
                    </em>{" "}
                  </strong>
                  with a manifestation of a progressive and peaceful society.
                </p>
              </div>
            </div>
          </div>
          <div className="row border-1">
            <div className="col-md-6 p-4">
              <div className="scroll-box">
                <h2 className="color-red text-center">School Motto</h2>
                <p></p>
                <p>
                  The School Motto{" "}
                  <strong className="partnershipitalic">
                    ‘Arise! Awake! And Stop Not till The Goal Is Reached’
                  </strong>{" "}
                  is the clarion call for scholars at Lotus Valley International
                  School Gurugram. We encourage our learners to discover their
                  passion and decide their goals in life.
                </p>
                <p>
                  We encourage them to find the joys of learning and make life a
                  very mindful and meaningful experience. We help our learners
                  discover who they really are and empower them to do what they
                  love.
                </p>
              </div>
            </div>
            <div className="col-md-6 p-0">
              <LazyLoad>
                {" "}
                <img
                  alt="lotus valley school, gurgaon"
                  className="img-fluid wid-100"
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/school.jpg"
                ></img>
              </LazyLoad>
            </div>
          </div>
          <div className="row border-1">
            <div className="col-md-6 p-0">
              <LazyLoad>
                {" "}
                <img
                  alt="lotus valley school, gurgaon"
                  className="img-fluid wid-100"
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/motto.jpg"
                ></img>
              </LazyLoad>
            </div>
            <div className="col-md-6 p-4">
              <div className="scroll-box">
                <h2 className="color-red text-center">School Emblem</h2>
                <p>
                  Lotus Valley International School is passionately committed to
                  pursue excellence in every conceivable field. For us every
                  child is a leader of tomorrow and we leave no
                  stone&nbsp;unturned to ensure that every Lotusian is given an
                  opportunity to excel
                  <strong>
                    <em>.</em>
                  </strong>
                </p>
                <p>
                  <strong>
                    The Four Segments of the Shield represent different aspects
                    of learning:
                  </strong>
                </p>
                <ol>
                  <li>
                    The <strong>GLOBE</strong> signifies the global outlook
                    necessary for the leaders of tomorrow.
                  </li>
                  <li>
                    The <strong>BOOK</strong> stands for knowledge.
                  </li>
                  <li>
                    The <strong>TORCH</strong> embodies hope and integrity that
                    ignite the minds of young people and light their path
                    towards brilliance and accomplishment.
                  </li>
                  <li>
                    The <strong>VEENA</strong> belongs to Saraswati, the Goddess
                    of learning and speech. It is the symbol of creativity,
                    culture and refinement.
                  </li>
                </ol>
                <p>
                  The school emblem draws inspiration from the five classical
                  elements - <strong>EARTH, WATER, FIRE, AIR and SKY</strong>.
                  We endeavour to instil in our learners the attributes of the
                  five great elements. With the Lotus of transcendence flanked
                  by two swans at the top, the crest highlights the subtlety of
                  sky and swan’s unique ability to separate milk from water,
                  just like the discovering minds we inculcate in our learners.
                </p>
                <p>
                  The colour <strong>BLUE</strong> reminds us of the flowing
                  nature of water and motivates learners to keep advancing
                  towards their goals. The colour <strong>YELLOW</strong> brings
                  alive the spirit of fire along with its strong will and energy
                  while the <strong>GOLDEN</strong> colour represents nurturing
                  and stable quality of earth. The flags with the initials of
                  the school are the omnipresent ambassadors of direction like
                  the ever-present air.
                </p>
                <p></p>
              </div>
            </div>
          </div>
          <div className="row border-1">
            <div className="col-md-6 p-4">
              <div className="scroll-box">
                <h2 className="color-red text-center">
                  Avant - Garde Philosophy
                </h2>
                <p></p>
                <p className="partnershipitalic">
                  {" "}
                  <strong>
                    <em>
                      “Education should bring to light the ideal of the
                      individual.”
                    </em>{" "}
                  </strong>
                </p>
                <p>
                  We believe that every child is unique. Each one has a
                  different pace of learning, which needs to be discovered by
                  the school. Therefore, Lotus Valley International School
                  strives to understand and fulfil the individual needs of its
                  learners.
                </p>
                <p>
                  We tickle the imagination of our children so that they can
                  think-out of-the-box and grasp concepts faster. We encourage
                  them to explore, experience, experiment and find their own
                  path of discovery. We provide them with a stimulating
                  environment where love, affection and joy bring out the best
                  in them.
                </p>
                <p>
                  We have an education system that builds the learners’
                  character and empowers them in all aspects – mental, physical,
                  emotional and social.
                </p>
              </div>
            </div>
            <div className="col-md-6 p-0">
              <LazyLoad>
                {" "}
                <img
                  alt="lotus valley school, gurgaon"
                  className="img-fluid wid-100"
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/philosophy.jpg"
                ></img>
              </LazyLoad>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default About;
